import { ReportConfirmationProducerPDF } from "./Components/PDF/ReportConfirmationProducerPDF";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { DrawerFilterConfirmationProducer } from "./Components/DrawerFilter/DrawerFilterConfirmationProducer";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportConfirmationProducer = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportConfirmationProducer } = useContextReportsProduction();

  const hasData = !!listReportConfirmationProducer?.data?.length;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterConfirmationProducer key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de parcelas de confirmação de produtor com filtros personalizados"
        title="Relatório de confirmação produtor"
      />

      <ReportConfirmationProducerPDF />
      {!hasData && !loadingGravar && (
        <NoEmptyPdfCore />
      )}
    </>
  );
};
